import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import configReducer from './configSlice';
import loginReducer from '../login/loginSlice';
import langReducer from '../lang/langSlice';
import tokenReducer from '../tokenHandling/tokenSlice';
import appReducer from '../../data/appSlice';
import accountReducer from '../../data/accountSlice';
import { monitorApi } from '../../services/monitorApi';

// Create the root reducer independently to obtain the RootState type
const rootReducer = combineReducers({
    config: configReducer,
    lang: langReducer,
    app: appReducer,
    account: accountReducer,
    login: loginReducer,
    tokenHandling: tokenReducer,

    // Add the generated reducer as a specific top-level slice
    [monitorApi.reducerPath]: monitorApi.reducer,
});

export const getStore = (preloadedState?: Partial<RootState>) =>
    configureStore({
        reducer: rootReducer,
        preloadedState,

        // Adding the api middleware enables caching, invalidation, polling,
        // and other useful features of `rtk-query`.
        middleware: getDefaultMiddleware => getDefaultMiddleware().concat(monitorApi.middleware),
    });

export const store = getStore();

// Infer the store, state and dispatch types from the store instance
export type RootState = ReturnType<typeof rootReducer>;
export type RootStore = ReturnType<typeof getStore>;
export type AppDispatch = RootStore['dispatch'];

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
